module.exports = __webpack_public_path__ + "media/images/short_scenario_contest/btn-apply@2x-0d56b263bf56378bf2e6d5bf21715a31.png";